import { useMemo, useRef } from "react";
import { BarChart, BarElementPath } from "@mui/x-charts";
import { PRODUCTION_COLORS } from "../../productionPalette";

const ModernProductionChart = ({ data, onBarClick }) => {
  const onBarClickRef = useRef(onBarClick);
  onBarClickRef.current = onBarClick;

  const CustomBar = useMemo(
    () =>
      function CustomBarSlot(props) {
        const { ownerState, ...rest } = props;
        return (
          <BarElementPath
            {...rest}
            ownerState={ownerState}
            onClick={
              onBarClickRef.current
                ? () => onBarClickRef.current(ownerState.dataIndex)
                : undefined
            }
          />
        );
      },
    []
  );

  const labels = data.map((item) => `${item.label} (${item.value})`);

  const series = data.map((item, index) => ({
    data: data.map((_, j) => (j === index ? item.value : null)),
    label: item.label,
    color: PRODUCTION_COLORS[index % PRODUCTION_COLORS.length],
    stack: "production",
    valueFormatter: (value) => (value === null ? null : `${value}`),
  }));

  return (
    <BarChart
      xAxis={[{ scaleType: "band", data: labels, barGapRatio: 0.1 }]}
      series={series}
      height={270}
      grid={{ horizontal: true }}
      tooltip={{ trigger: "item" }}
      slots={onBarClick ? { bar: CustomBar } : undefined}
      slotProps={{ legend: { hidden: true } }}
      sx={{
        "& .MuiBarElement-root": {
          rx: 4,
          cursor: onBarClick ? "pointer" : "default",
        },
        "& .MuiChartsAxis-line, & .MuiChartsAxis-tick": {
          stroke: "var(--profile-border)",
        },
        "& .MuiChartsGrid-line": {
          stroke: "var(--profile-border)",
        },
        "& .MuiChartsAxis-tickLabel": {
          fill: "var(--profile-ink-secondary)",
        },
      }}
    />
  );
};

export default ModernProductionChart;
